import { render, staticRenderFns } from "./RequestDealsBlock.vue?vue&type=template&id=4169c9fe&scoped=true&"
import script from "./RequestDealsBlock.vue?vue&type=script&lang=js&"
export * from "./RequestDealsBlock.vue?vue&type=script&lang=js&"
import style0 from "./RequestDealsBlock.vue?vue&type=style&index=0&id=4169c9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4169c9fe",
  null
  
)

component.options.__file = "RequestDealsBlock.vue"
export default component.exports